import type { ContactAddress } from '@personical/cc-shared-types';
import { ISO_COUNTRY_CODES, countryCode, countryName } from '@personical/cc-shared-types';

let options: { code: string; name: string }[] | null = null;

/** Countries for the address picker, by name in the browser's language. */
export function countryOptions(locale?: string): { code: string; name: string }[] {
  options ??= ISO_COUNTRY_CODES.map((code) => ({
    code,
    name: countryName(code, locale ?? globalThis.navigator?.language)
  })).sort((a, b) => a.name.localeCompare(b.name));
  return options;
}

/**
 * The address as the form sends it: trimmed parts, blank ones (and blank
 * street lines) left out, the country as its ISO code; null when nothing
 * is filled in, so saving clears a stored address.
 */
export function addressPayload(a: ContactAddress | null | undefined): ContactAddress | null {
  const out: ContactAddress = {};
  const street = (a?.street ?? '')
    .split(/\r?\n/)
    .map((l) => l.trim())
    .filter(Boolean)
    .join('\n');
  if (street) out.street = street;
  for (const f of ['city', 'region', 'postalCode'] as const) {
    const v = a?.[f]?.trim();
    if (v) out[f] = v;
  }
  const country = a?.country ? countryCode(a.country) : undefined;
  if (country) out.country = country;
  return Object.keys(out).length > 0 ? out : null;
}
